import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import { useI18n } from '@/libraries/contexts/i18n-context';
import styles from './star-rating.module.scss';

export interface StarRatingProps {
  /** The class name to apply */
  className?: string;
  /** The rating value */
  rating: number;
}

const LENGTH = 5;

const StarRating = ({ className, rating }: StarRatingProps) => {
  const { t } = useI18n();

  const renderStar = (index: number) => {
    const isFullStar = rating >= index + 1;
    const isHalfStar = !isFullStar && rating > index;

    return (
      <div key={index} className={styles.star}>
        {isFullStar && (
          <Icon
            className={classNames(styles.starIcon, styles.isFull)}
            name="StarFilled"
            size={24}
          />
        )}

        {isHalfStar && (
          <Icon
            className={classNames(styles.starIcon, styles.isHalf)}
            name="StarHalfFilled"
            size={24}
          />
        )}

        {!isFullStar && !isHalfStar && (
          <Icon
            className={classNames(styles.starIcon, styles.isEmpty)}
            name="StarOutline"
            size={24}
          />
        )}
      </div>
    );
  };

  return (
    <div
      aria-label={t('items.search.productCard.rating', {
        LENGTH,
        rating,
      })}
      className={classNames(styles.component, className)}
      role="img"
    >
      {Array.from({ length: LENGTH }, (_, index) => renderStar(index))}
    </div>
  );
};

StarRating.displayName = 'StarRating';

export default StarRating;
